module.exports = __webpack_public_path__ + "img/background049.88018822.jpg";